module.exports = __webpack_public_path__ + "img/jobs@3x.b195599.png";